import { createSelector } from '@ngrx/store';
import { Order, OrderLineItem } from '../../models/order.model';
import * as fromRoot from '../../../store';
import * as fromFeature from '../reducers';
import * as fromAuth from '../reducers/customer.reducer';
import { Customer } from '../../models';

export const getCustomerState = createSelector(fromFeature.getShopifyState, (state: fromFeature.ShopifyState) => state.customer);

export const getAuthUser = createSelector(getCustomerState, fromAuth.getAuthUser);
export const getAuthError = createSelector(getCustomerState, fromAuth.getAuthError);
export const getUser = createSelector(getCustomerState, fromAuth.getUser);

export const getCustomerAccessToken = createSelector(getCustomerState, fromAuth.getCustomerAccessToken);

export const getCustomerTokenAndEmail = createSelector(getCustomerAccessToken, getUser, (token, user) => {
  return {
    token,
    email: user?.email,
  };
});

export const getCustomer = createSelector(getCustomerState, fromAuth.getCustomer);
export const getCustomerLoading = createSelector(getCustomerState, fromAuth.getCustomerLoading);
export const getCustomerLoaded = createSelector(getCustomerState, fromAuth.getCustomerLoaded);

export const getCustomerDefaultAddress = createSelector(getCustomerState, state => {
  return (state.customer as Customer)?.defaultAddress;
});

export const getCustomerVatNumber = createSelector(getCustomerState, state => {
  const customer = state.customer as Customer;
  return customer?.metafield?.key === 'vat_number' ? customer.metafield?.value : null;
});

export const getCustomerHasVatNumber = createSelector(getCustomerVatNumber, vatNumber => {
  // console.log('btw', vatNumber);
  return vatNumber !== null;
});

export const getRegistering = createSelector(getCustomerState, fromAuth.getRegistering);
export const getRegisterSuccess = createSelector(getCustomerState, fromAuth.getRegisterSuccess);
export const getRegisterError = createSelector(getCustomerState, fromAuth.getRegisterError);

export const getCustomerRecovering = createSelector(getCustomerState, fromAuth.getCustomerRecovering);
export const getCustomerRecovered = createSelector(getCustomerState, fromAuth.getCustomerRecovered);
export const getCustomerRecoveredErrors = createSelector(getCustomerState, fromAuth.getCustomerRecoveredErrors);

export const getCustomerActivated = createSelector(getCustomerState, fromAuth.getCustomerActivated);
export const getCustomerActivating = createSelector(getCustomerState, fromAuth.getCustomerActivating);

export const getCustomerReset = createSelector(getCustomerState, fromAuth.getCustomerReset);
export const getCustomerResetting = createSelector(getCustomerState, fromAuth.getCustomerResetting);
export const getCustomerResetErrors = createSelector(getCustomerState, fromAuth.getCustomerResetErrors);

export const getCustomerUpdated = createSelector(getCustomerState, fromAuth.getCustomerUpdated);
export const getCustomerUpdating = createSelector(getCustomerState, fromAuth.getCustomerUpdating);
export const getCustomerUpdatingErrors = createSelector(getCustomerState, fromAuth.getCustomerUpdatingErrors);

export const getTokenInitialized = createSelector(getCustomerState, fromAuth.getTokenInitialized);
export const getTokenInitializing = createSelector(getCustomerState, fromAuth.getTokenInitializing);

export const getInviteSent = createSelector(getCustomerState, fromAuth.getInvitationSent);
export const getInviteSending = createSelector(getCustomerState, fromAuth.getInvitationSending);

export const getLoadingAsDefaultAddress = createSelector(getCustomerState, fromAuth.getLoadingAsDefaultAddress);

export const getCustomerSigningIn = createSelector(getCustomerState, fromAuth.getCustomerSigningIn);
export const getCustomerSignedIn = createSelector(getCustomerAccessToken, token => {
  if (!token) {
    return false;
  }

  return new Date(token.expiresAt).getTime() > new Date().getTime();
});
